module.exports = __webpack_public_path__ + "img/one.f7759cc0.png";